var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.706 1.03647C6.38323 1.43621 2.99865 5.07285 2.99865 9.5C2.99865 10.45 3.1545 11.3636 3.44202 12.2166C3.55022 12.5376 3.60432 12.6981 3.61408 12.8214C3.62371 12.9432 3.61643 13.0286 3.5863 13.1469C3.5558 13.2668 3.48844 13.3915 3.35374 13.6408L1.71808 16.6684C1.48477 17.1002 1.36812 17.3161 1.39423 17.4828C1.41697 17.6279 1.5024 17.7557 1.62782 17.8322C1.77183 17.9201 2.01595 17.8948 2.50419 17.8444L7.62521 17.315C7.78023 17.299 7.85785 17.291 7.92851 17.2937C7.99802 17.2963 8.04709 17.3029 8.11488 17.3185C8.1838 17.3344 8.27047 17.3678 8.4438 17.4345C9.39185 17.7998 10.4219 18 11.4986 18C15.9294 18 19.5684 14.6098 19.9632 10.2819M19.12 1.87868C20.2915 3.05025 20.2915 4.94975 19.12 6.12132C17.9484 7.29289 16.0489 7.29289 14.8773 6.12132C13.7058 4.94975 13.7058 3.05025 14.8773 1.87868C16.0489 0.707107 17.9484 0.707107 19.12 1.87868Z",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.bb6c759c9ae791b91323308d6409dae8.svg";
export { ForwardRef as ReactComponent };